import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Package = function Package(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 8.13086L21.2676 6.08984C21.1113 5.93359 20.9258 5.80664 20.6816 5.67969L13.8359 1.83203C13.2305 1.49023 12.6055 1.31445 12 1.31445C11.3848 1.31445 10.7598 1.49023 10.1543 1.83203L8.2793 2.88672L17.6445 8.13086ZM11.9902 11.2852L16.1406 8.96094L6.82422 3.70703L3.30859 5.67969C3.07422 5.80664 2.87891 5.93359 2.72266 6.08984L11.9902 11.2852ZM12.7129 22.6621C12.8105 22.6426 12.8984 22.5938 12.9961 22.5449L20.5547 18.3066C21.502 17.7695 21.9902 17.2129 21.9902 15.8164V8.00391C21.9902 7.75977 21.9707 7.55469 21.9219 7.35938L12.7129 12.5547V22.6621ZM11.2773 22.6621V12.5547L2.06836 7.35938C2.01953 7.55469 2 7.75977 2 8.00391V15.8164C2 17.2129 2.48828 17.7695 3.43555 18.3066L10.9941 22.5449C11.082 22.5938 11.1797 22.6426 11.2773 22.6621Z"
  })));
};

Package.displayName = 'Package';
export default Package;